import { Box, Divider, Grid, MenuItem, Tab, Tabs, Typography } from '@mui/material'
import domtoimage from 'dom-to-image'
import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API */
import { fileUrl } from 'api/api'
import RetrospectiveApi from 'api/counter/retrospective-order.api'
import TreatmentsAPI from 'api/dentists/treatment.api'
import ClinicApi from 'api/master/clinic.api'

/** UTILS || SLICE */
import { showModal } from 'app/slice/modal.slice'
import { TreatmentStateInterface, setEditTootChart, setEditTootChartType, setHistoryToothChart, setToothChartSelected, setTreatmentByKey, treatment } from 'app/slice/treatment.slice'
import { selectMe } from 'app/slice/user.slice'
import { exportOPD, exportSSO } from 'component/Print/exportPdf'
import { checkPackage, getBranch, getClinicInfo, getServicePoint } from 'utils/app.utils'
/** CONSTANTS */
import { icons, imgs } from 'constants/images'
import { colors } from 'constants/theme'

/** COMPONENT */
import { swalCustom, swalWarning } from 'component/Alert/Swal'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewDatePicker from 'component/Input/InputSecondNewDatePicker'
import Loading from 'component/Loading'
import SearchPatients, { SearchPatientValue } from 'component/SearchPatients'
import BtnProfile from 'component/Treatments/BtnProfile'
import MedicalCertificate from 'component/Treatments/MedicalCertificate'
import PopupPatientDetail from 'component/Treatments/PopupPatientDetail'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import PopupPayment from 'features/finance/payment/component/popupPayment/Index'
import FragmentFooter from 'features/treatments/FragmentFooter'
import IndexDoctorNote from 'features/treatments/MainMenu/DoctorNote/Index'
import IndexImage from 'features/treatments/MainMenu/Image/Index'
import IndexOPD from 'features/treatments/MainMenu/OPD/Index'
import IndexVitalSign from 'features/treatments/MainMenu/VitalSign/Index'
import IndexSummaryTreatment from 'features/treatments/SummaryTreatment/Index'
import { RawAdditionalType, RawDiscountType, renderSumAdditional, renderSumDiscount } from 'features/treatments/SummaryTreatment/SummaryTreatment'
import { DoctorsType, SUB_TABS_NAME, TABS_NAME } from 'features/treatments/treatmentsIndex'

/** STYLE */
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ApprovalStatus } from 'api/approval/approval.api'
import PersonnelApi from 'api/setting/personnel-managements/personnel.api'
import { resetStatePayment } from 'app/slice/payment.slice'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { Config } from 'config'
import { PACKAGE_ADDONS } from 'constants/package'
import { format } from 'date-fns'
import * as UseStyled from 'features/retrospectiveOrder/UseStyle'
import * as TreatmentsUseStyled from 'features/treatments/UseStyle'
import MainButton from 'new-components/buttons/main-button'
import DateInput from 'new-components/inputs/date-input'
import DateRangeInput from 'new-components/inputs/date-range-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import { DateObject } from 'react-multi-date-picker'
import { dateToView } from 'utils/date.utils'

interface TabPanelProps {
  children?: React.ReactNode
  index: string
  value: string
}

export default function RetrospectiveOrder() {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(selectMe)
  const branch = getClinicInfo()
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const footerTabs: string[] = ['TREATMENTS.FOOTER_TAB.SUMMARY_TREATMENT', 'TREATMENTS.FOOTER_TAB.DIAGNOSIS', 'TREATMENTS.FOOTER_TAB.RECOMMEND']
  const [tabs, setTabs] = useState<TABS_NAME[]>([TABS_NAME.OPD, TABS_NAME.DOCTOR_NOTE, TABS_NAME.IMAGE, TABS_NAME.VITAL_SIGN])
  // [SUB_TABS_NAME.DX, SUB_TABS_NAME.TX, SUB_TABS_NAME.TXC, SUB_TABS_NAME.TXP, SUB_TABS_NAME.MED, SUB_TABS_NAME.PD]
  const [subTabs, setSubTabs] = useState<SUB_TABS_NAME[]>([])
  const [activeTab, setActiveTab] = useState<TABS_NAME>(TABS_NAME.OPD)
  const [activeSubTab, setActiveSubTab] = useState<SUB_TABS_NAME>(SUB_TABS_NAME.TX)
  const [activeFooterTab, setActiveFooterTab] = useState(0)

  const [errorMessage, setErrorMessage] = useState({
    EMPTY_DATE: ''
  })

  const [sendPayment, setSendPayment] = useState(false)

  const [anchorElTabletTabs, setAnchorElTabletTabs] = useState<null | HTMLElement>(null)
  const openTabletTabs = Boolean(anchorElTabletTabs)
  const [tabletWidth, setTabletWidth] = useState(0)

  const [anchorElMobileTabs, setAnchorElMobileTabs] = useState<null | HTMLElement>(null)
  const openMobileTabs = Boolean(anchorElMobileTabs)
  const [mobileWidth, setMobileWidth] = useState(0)

  const [doctors, setDoctors] = useState<DoctorsType[]>([])
  const [date, setDate] = useState('')
  const [netDiscount, setNetDiscount] = useState<number>(0)
  const [netAdditional, setNetAdditional] = useState<number>(0)
  const [retrospectiveOrder, setRetrospectiveOrder] = useState({})

  const [patientBranch, setPatientBranch] = useState<number | null>(null)
  const [patientId, setPatientId] = useState(0)
  const [patient, setPatient]: any = useState({})
  const [isShowPopupDetail, setIsShowPopupDetail] = useState<boolean>(false)

  const [exportMedicalCertificate, setExportMedicalCertificate] = useState(false)

  const [loading, setLoading] = useState(false)

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenAlertWarning, setIsOpenAlertWarning] = useState(false)
  const [isOpenAlertError, setIsOpenAlertError] = useState(false)
  const [retrospectiveList, setRetrospectiveList] = useState([])
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(5)
  const [rowCount, setRowCount] = useState(0)
  const [search, setSearch] = useState('')
  const [dateModal, setDateModal] = useState('')
  const [rangeDate, setRangeDate] = useState<string[]>(['', ''])
  const [optionUsers, setOptionUsers] = useState([])
  const [userId, setUserId] = useState([])
  const [resultUserId, setResultUserId] = useState('')



  const loadDoctor = async () => {
    const resp = await ClinicApi.findAllDoctors()
    if (resp.status === 200) setDoctors(resp.data)
  }

  const loadPatient = async (valuePatientId: number) => {
    const data: any = []
    if (valuePatientId) {
      const patientData = await TreatmentsAPI.findPatient(valuePatientId)
      if (patientData.status === 200 && !_.isEmpty(patientData.data)) {
        setPatient(patientData.data)
      } else setPatient([])
      await TreatmentsAPI.findInstallmentTx(valuePatientId).then((resp) => {
        if (resp.status === 200) {
          const resultValue = _.map(resp.data, (item) => ({ ...item, price: item?.installment?.totalPrice, fullPrice: _.find(item?.installment?.installmentList, (item) => item.status === 'PENDING')?.price, total: _.find(item?.installment?.installmentList, (item) => item.status === 'PENDING')?.price }))
          if (resultValue?.length > 0) data?.push(...resultValue)
          dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: resultValue }))
        }
      })
      await RetrospectiveApi.getRetrospectivePatient(valuePatientId).then((resp: any) => {
        if (resp.data?.summeryTreatments?.length > 0) {
          data.push(...resp.data?.summeryTreatments)
          data.push(...resp.data?.summeryProducts)
          dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: data }))
        }
        dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: resp.data?.patientDiagnosis || [] }))
        dispatch(setTreatmentByKey({ key: 'patientRecommends', value: resp.data?.patientRecommends || [] }))
      })
      setIsOpenAlertWarning(data?.length > 0 ? true : false)
    }
  }

  const loadRetrospectiveOrderList = async () => {
    await RetrospectiveApi.getRetrospectiveList({
      page: page,
      pageLimit: pageLimit,
      search: search,
      date: dateModal,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      userId: resultUserId
    })
      .then((resp: any) => {
        setRowCount(resp.headers['x-total'])
        setRetrospectiveList(resp.data)
      })
  }

  const loadUsersList = async () => {
    await PersonnelApi.findAll({ page: 1, pageLimit: 999 }).then((resp) => {
      const data: any = _.map(resp.data, (item) => ({ name: item.username, id: item.userId }))
      setOptionUsers(data)
    })
  }

  const loadRetrospectivePatient = async (id: number) => {
    setPatientId(id)
    setPatientBranch(branch?.branchId)
    const patientData = await TreatmentsAPI.findPatient(id)
    if (patientData.status === 200 && !_.isEmpty(patientData.data)) {
      setPatient(patientData.data)
    } else setPatient([])
    await RetrospectiveApi.getRetrospectivePatient(id).then((resp: any) => {
      setDate(resp.data?.date)
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...resp.data?.summeryTreatments, ...resp.data?.summeryProducts] }))
      dispatch(setTreatmentByKey({ key: 'summeryProducts', value: [] }))
      dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: resp.data?.patientDiagnosis }))
      dispatch(setTreatmentByKey({ key: 'patientRecommends', value: resp.data?.patientRecommends }))
      dispatch(setTreatmentByKey({ key: 'date', value: resp.data?.date }))
      dispatch(setTreatmentByKey({ key: 'servicePointId', value: resp.data?.servicePointId }))
      dispatch(setTreatmentByKey({ key: 'teethType', value: resp.data?.teethType }))
      dispatch(setTreatmentByKey({ key: 'toothChart', value: resp.data?.toothChart }))
      // dispatch(setTreatment({ value: resp.data }))
    })
  }

  const onSaveRetrospective = async (id: number) => {

    if (!date) {
      setLoading(false)
      $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
      return setErrorMessage({ ...errorMessage, EMPTY_DATE: t('RETROSPECTIVE_ORDER.MESSAGE.ERROR.EMPTY_DATE') })
    }
    const summeryTreatments: any = []
    const summeryProducts: any = []
    const summeryDiagnosis: any = []
    const summeryRecommends: any = []
    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      if (i.operativeId) {
        summeryTreatments.push({
          index: index + 1,
          teeth: i?.teeth || null,
          teethJson: i?.teethJson || null,
          operativeId: i.operativeId || 0,
          qty: Number(i.qty) || 0,
          price: Number(i.price) || 0,
          doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : null,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || '',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit,
          dfAmount: (i.dfAmount || i.cfAmount) ? Number(i.dfAmount) : null,
          dfUnit: i.dfUnit || null,
          dfDiscountAmount: Number(i.dfDiscountAmount) || 0,
          dfDiscountUnit: i.dfDiscountUnit || '',
          dfAmountNet: Number(i.dfAmountNet) || 0,
          cfAmount: (i.dfAmount || i.cfAmount) ? Number(i.cfAmount) : null,
          cfDiscountAmount: Number(i.cfDiscountAmount) || 0,
          cfDiscountUnit: i.cfDiscountUnit || '',
          cfAmountNet: Number(i.cfAmountNet) || 0,
          dfRemark: i.dfRemark || '',
          clinicFeeId: Number(i.clinicFeeId) || null,
          total: Number(i.total) || 0,
          note: i.note || '',
          noteNextVisit: i.noteNextVisit || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          nextVisit: i.nextVisit || null,
          commission: i.commission || 0,
          isChangeCost: i?.isChangeCost || "0",
          bodyData: i?.bodyData || "",
          newBodyData: i?.newBodyData || "",
          requestReason: i?.requestReason || "",
          promotion: i?.promotion?.length ? i?.promotion.map((item: any) => {
            return {
              promotionBranchId: item?.promotionBranchId,
              promotionType: item?.promotionType || item?.type,
              promotionId: item?.promotionId,
              isMain: item?.isMain || '0',
              groupNumber: item?.groupNumber || 0
            }
          }) : [],
          promotionDiscount: i?.promotionDiscount || 0,
          promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
          dfPromotionDiscountAmount: i?.dfPromotionDiscountAmount || 0,
          dfPromotionDiscountUnit: i?.dfPromotionDiscountUnit || "BAHT",
          cfPromotionDiscountAmount: i?.cfPromotionDiscountAmount || 0,
          cfPromotionDiscountUnit: i?.cfPromotionDiscountUnit || "BAHT",
          voucherListId: i?.voucherListId || 0,
          voucherDiscount: i?.voucherDiscount || 0,
          voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
          dfVoucherDiscountAmount: i?.dfVoucherDiscountAmount || 0,
          dfVoucherDiscountUnit: i?.dfVoucherDiscountUnit || "BAHT",
          cfVoucherDiscountAmount: i?.cfVoucherDiscountAmount || 0,
          cfVoucherDiscountUnit: i?.cfVoucherDiscountUnit || "BAHT",
          installment: i?.installment || null,
        })
      }

      if (i.group !== 'ALL' && !i.operativeTypeId) {
        summeryProducts.push({
          index: index + 1,
          inventoryId: i.inventoryId,
          group: i.group,
          qty: Number(i.qty),
          price: Number(i.price),
          doctorId: _.some(doctors, { userId: i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || 'BAHT',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit || 'BAHT',
          note: i.note || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          total: Number(i.total) || 0,
          sticker: i.sticker || null,
        })
      }
    })

    _.map(treatments.patientDiagnosis, (i: any, index: number) => {
      summeryDiagnosis.push({
        // patientDiagnosisId: i.patientDiagnosisId || null,
        diagnosisCode: i.diagnosisCode,
        diagnosisName: i.diagnosisName,
        diagnosisId: Number(i.diagnosisId) || 0,
        doctorId: _.some(doctors, { userId: Number(i.doctorId) }) ? Number(i.doctorId) : null,
        note: i.note || '',
        teeth: i?.teeth || null,
        teethJson: i?.teethJson || null,
        teethType: i?.teethType || treatments?.teethType || 'ADULT',
        // refItemId: JSON.stringify(i?.refItemId || '[]') || '[]'
      })
    })

    _.map(treatments.patientRecommends, (i: any, index: number) => {
      summeryRecommends.push({
        patientRecommendId: i.patientRecommendId || null,
        recommendId: i.recommendId,
        refItemId: JSON.stringify(i?.refItemId || '[]') || '[]',
        recommendText: i.recommendText || ''
      })
    })
    const summary = {
      date: treatments.date || date,
      toothChart: treatments.toothChart,
      teethType: treatments?.teethType || 'ADULT',
      servicePointId: treatments.servicePointId,
      summeryTreatments: summeryTreatments,
      summeryProducts: summeryProducts,
      patientDiagnosis: summeryDiagnosis,
      patientRecommends: summeryRecommends,
    }
    await RetrospectiveApi.postRetrospectivePatient(id, summary).then(() => notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'), '', null, null, 'register-page')).catch((e) => {
      const message = e?.response?.data?.message
      if (message === 'TREATMENT_NOT_FOUND' || message === 'PRODUCT_NOT_FOUND') {
        return swalWarning(`รายการ ${e?.response?.data?.name} นั้นถูกลบไปแล้ว กรุณาลบรายการออก`)
      } else if (message === 'PRODUCT_NOT_ENOUGH' || message === 'MEDICINE_NOT_ENOUGH') {
        notiError(`${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT')} ${e?.response?.data?.name || ''} ${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT_NOT')}`)
      } else if (message === 'RECOMMEND_ID_ANY_REQUIRED') {
        notiError(t('กรุณากรอกคำแนะนำ หรือลบคำแนะนำออก'), '', null, null, 'register-page')
      } else if (message === 'DOCTOR_ID_NUMBER_BASE') {
        notiError(t('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_DOCTOR'), '', null, null, 'register-page')
      } else {
        notiError(t('เกิดข้อผิดพลาด'), '', null, null, 'register-page')
      }
    })
  }

  const onDeleteRetrospective = async (id: number) => {
    await RetrospectiveApi.deleteRetrospectivePatient(id).then(() => {
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [] }))
      setIsOpenAlertError(false)
      setIsOpenAlertWarning(false)
    })
  }

  const getPatient = (val: SearchPatientValue) => {
    if (val?.patientId) {
      setPatientId(val.patientId)
      loadPatient(val.patientId)
      setPatientBranch(val?.branchId)
    }
  }

  const getPatientId = (id: number) => {
    setPatientId(id)
    loadPatient(id)
  }

  const clearPatient = () => {
    setPatientId(0)
    setPatient({})
    clearOperative()
  }

  const clearOperative = () => {
    setDate('')
    dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [] }))
    dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: [] }))
    dispatch(setTreatmentByKey({ key: 'patientRecommends', value: [] }))
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
    dispatch(setToothChartSelected([]))
    dispatch(setHistoryToothChart([]))
    setErrorMessage({ EMPTY_DATE: '' })
  }

  const onViewHistory = () => {
    dispatch(showModal())
    setIsShowPopupDetail(true)
  }

  const renderImage = (img: any) => {
    if (!_.isEmpty(img) && !_.isEmpty(img.filePath) && !_.isEmpty(img.fileName)) return `${fileUrl}/${img.filePath}/${img.fileName}`
    else return imgs.defaultAvatar
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(tabs[newValue])
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
  }

  const handleOpenDropDown = () => {
    const dropdownTabletWidth = Array.from(document.getElementsByClassName('btn-dropdown-menu-tablet-tab') as HTMLCollectionOf<HTMLElement>)
    const dropdownMobileWidth = Array.from(document.getElementsByClassName('btn-dropdown-menu-mobile-tab') as HTMLCollectionOf<HTMLElement>)
    setTabletWidth(Number(dropdownTabletWidth[0]?.offsetWidth))
    setMobileWidth(Number(dropdownMobileWidth[0]?.offsetWidth))
  }

  const onCloseMenu = () => {
    setAnchorElMobileTabs(null)
    setAnchorElTabletTabs(null)
  }

  useEffect(() => {
    if (treatments.summeryTreatments?.length > 0) {
      const index = _.findLastIndex(treatments.summeryTreatments, (item: any) => item.teethType)
      if (treatments.summeryTreatments[index]) {
        dispatch(setTreatmentByKey({ key: 'teethType', value: treatments.summeryTreatments[index].teethType }))
      }
    }
    const isReloadApproval = treatments?.summeryTreatments.some((item: any) => item?.isChangeCost === "1")
    if (treatments?.summeryTreatments && isReloadApproval) {
      onSaveSummary(patient.patientId)
    }
  }, [treatments.summeryTreatments])

  const onHandleSaveToothChart = async () => {
    const toothChartFile = {
      fileId: null,
      base64: '',
      type: '',
      fileSize: '',
      fileExtension: 'png'
    }
    let node: any = ''
    if (treatments.teethType === 'ADULT') {
      node = document.getElementById('tooth-chart')
    } else {
      node = document.getElementById('tooth-chart-child')
    }
    if (node) {
      let base64 = await domtoimage.toPng(node)
      if (base64) {
        const re = 'data:image/png;base64,'
        base64 = base64.replace(re, "'")
        toothChartFile.base64 = base64
      }
    }

    return toothChartFile
  }

  const handleErrorApprovalPending = () => {
    setLoading(false)
    swalCustom(
      t('APPROVELLIST.FILTER.PENDING'),
      `<div >${t('APPROVELLIST.MESSAGE.SAVE_APPROVAL_TITLE')} ${t('APPROVELLIST.MESSAGE.SAVE_APPROVAL_SUB')}</div>`,
      () => console.log(),
      'warning',
      {
        cancelButton: { cancelButtonText: t('BUTTON.ENTER') },
        confirmButton: { showConfirmButton: false },
        showCloseButton: false,
      }
    )
  }

  const onPayment = async () => {
    setLoading(true)
    const branchCurrent = getBranch()
    if (!patientBranch || patientBranch !== branchCurrent) {
      setLoading(false)
      const branchInfo = getClinicInfo()
      const lang = i18n.language !== 'th' ? "En" : ""
      const handleCallbackNoti = (check: any) => {
        clearPatient()
        dispatch(resetStatePayment())
        return
      }
      const opSwal = {
        cancelButton: {
          showCancelButton: false
        }
      }
      swalCustom(
        t(`RETROSPECTIVE_ORDER.MESSAGE.REGISTERPATIENT`, { branchName: branchInfo?.[`branchName${lang}`] }),
        t(`RETROSPECTIVE_ORDER.MESSAGE.REGISTERPATIENT_SUB`, { branchName: branchInfo?.[`branchName${lang}`] }),
        handleCallbackNoti,
        null,
        opSwal
      )
      return
    }

    if (!date) {
      setLoading(false)
      $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
      return setErrorMessage({ ...errorMessage, EMPTY_DATE: t('RETROSPECTIVE_ORDER.MESSAGE.ERROR.EMPTY_DATE') })
    }
    if (!treatments.summeryTreatments.length) {
      setLoading(false)
      return swalWarning(t('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_TREATMENT'), '', null)
    }

    if (treatments.summeryTreatments?.some((item: any) => item?.approvalItems?.status === ApprovalStatus.PENDING)) {
      return handleErrorApprovalPending()
    }

    const retrospective: any = {
      date: date,
      teethType: treatments?.teethType || 'ADULT',
      servicePointId: Number(getServicePoint())
    }
    const summeryTreatments: any = []
    const summeryProducts: any = []
    const summeryDiagnosis: any = []
    const summeryRecommends: any = []

    retrospective.toothChart = await onHandleSaveToothChart()

    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      if (i.operativeTypeId) {

        let installment = null
        if (i.installment) {
          installment = {
            totalPrice: i.installment?.totalPrice,
            refType: i.installment?.refType,
            installmentItemPrice: i.installment?.totalPrice,
            installmentPaymentId: i.installment?.installmentPaymentId,
            installmentList: i.installment?.installmentList,
          }
        }
        let promotion = null
        if (i.promotion) {
          promotion = [{
            promotionBranchId: i.promotion?.promotionBranchId,
            promotionType: i.promotion?.promotionType,
            promotionId: i.promotion?.promotionId,
            isMain: i.promotion?.isMain,
            groupNumber: 0
          }]
        }
        summeryTreatments.push({
          index: index + 1,
          teeth: i?.teeth || null,
          teethJson: i?.teethJson || null,
          operativeId: i.operativeId || 0,
          qty: Number(i.qty) || 0,
          price: Number(i.price) || 0,
          doctorId: _.some(doctors, { userId: i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || '',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit,
          dfAmount: i.dfAmount || i.cfAmount ? Number(i.dfAmount) : null,
          dfUnit: i.dfUnit || '',
          dfDiscountAmount: Number(i.dfDiscountAmount) || 0,
          dfDiscountUnit: i.dfDiscountUnit || '',
          dfAmountNet: Number(i.dfAmountNet) || 0,
          cfAmount: i.dfAmount || i.cfAmount ? Number(i.cfAmount) : null,
          cfDiscountAmount: Number(i.cfDiscountAmount) || 0,
          cfDiscountUnit: i.cfDiscountUnit || '',
          cfAmountNet: Number(i.cfAmountNet) || 0,
          dfRemark: i.dfRemark || '',
          clinicFeeId: Number(i.clinicFeeId) || null,
          total: Number(i.total) || 0,
          note: i.note || '',
          noteNextVisit: i.noteNextVisit || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          nextVisit: i.nextVisit || null,
          promotion: promotion || [],
          promotionDiscount: i.promotionDiscount || 0,
          promotionDiscountUnit: i.promotionDiscountUnit || "BAHT",
          dfPromotionDiscountAmount: i.dfPromotionDiscountAmount || 0,
          dfPromotionDiscountUnit: i.dfPromotionDiscountUnit || "BAHT",
          cfPromotionDiscountAmount: i.cfPromotionDiscountAmount || 0,
          cfPromotionDiscountUnit: i.cfPromotionDiscountUnit || "BAHT",
          voucherListId: i.voucherListId || null,
          voucherDiscount: i.voucherDiscount || 0,
          voucherDiscountUnit: i.voucherDiscountUnit || "BAHT",
          dfVoucherDiscountAmount: i.dfVoucherDiscountAmount || 0,
          dfVoucherDiscountUnit: i.dfVoucherDiscountUnit || "BAHT",
          cfVoucherDiscountAmount: i.cfVoucherDiscountAmount || 0,
          cfVoucherDiscountUnit: i.cfVoucherDiscountUnit || "BAHT",
          installment: installment || null,
        })
      }

      if (!i.operativeTypeId) {
        summeryProducts.push({
          index: index + 1,
          inventoryId: i.inventoryId,
          group: i.group,
          qty: Number(i.qty),
          price: Number(i.price),
          doctorId: _.some(doctors, { userId: i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || 'BAHT',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit || 'BAHT',
          note: i.note || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          total: Number(i.total) || 0,
          sticker: i.sticker
        })
      }
    })

    _.map(treatments.patientDiagnosis, (i: any, index: number) => {
      summeryDiagnosis.push({
        // patientDiagnosisId: i.patientDiagnosisId || null,
        diagnosisId: Number(i.diagnosisId) || 0,
        doctorId: _.some(doctors, { userId: Number(i.doctorId) }) ? Number(i.doctorId) : 0,
        note: i.note || '',
        teeth: i?.teeth || null,
        teethJson: i?.teethJson || null,
        teethType: i?.teethType || treatments?.teethType || 'ADULT',
      })
    })

    _.map(treatments.patientRecommends, (i: any, index: number) => {
      summeryRecommends.push({
        patientRecommendId: i.patientRecommendId || null,
        recommendId: i.recommendId
      })
    })

    if (_.some(summeryTreatments, { qty: 0 }) || _.some(summeryProducts, { qty: 0 })) {
      setLoading(false)
      return notiError(t(`TREATMENT_SUMMARY.MESSAGE.${_.some(summeryTreatments, { qty: 0 }) ? 'NO_OPERATIVE_QTY' : 'NO_PRODUCT_QTY'}`), '', null, null, 'register-page')
    }

    if (_.some(summeryTreatments, { doctorId: 0 })) {
      setLoading(false)
      return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_TREATMENT'), '', null, null, 'register-page')
    }

    // if (_.some(summeryProducts, { group: 'MEDICINE', doctorId: 0 })) {
    //   setLoading(false)
    //   return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_MEDICINE'), '', null, null, 'register-page')
    // }

    retrospective.summeryTreatments = summeryTreatments
    retrospective.summeryProducts = summeryProducts
    retrospective.patientDiagnosis = []
    retrospective.patientRecommends = summeryRecommends

    setRetrospectiveOrder(retrospective)
    setLoading(false)
    setSendPayment(true)
  }

  const onSaveSummary = async (patientId: number) => {
    setLoading(true)
    const summeryTreatments: any = []
    const summeryProducts: any = []
    const summeryDiagnosis: any = []
    const summeryRecommends: any = []
    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      if (i.operativeTypeId) {
        summeryTreatments.push({
          index: index + 1,
          // tempOrderTreatmentId: i.tempOrderTreatmentId || null,
          teeth: i?.teeth || null,
          teethJson: i?.teethJson || null,
          operativeId: i.operativeId || 0,
          qty: Number(i.qty) || 0,
          price: Number(i.price) || 0,
          doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || '',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit,
          dfAmount: i.dfAmount === null && i.cfAmount === null ? null : Number(i.dfAmount),
          dfUnit: i.dfUnit || '',
          dfDiscountAmount: Number(i.dfDiscountAmount) || 0,
          dfDiscountUnit: i.dfDiscountUnit || '',
          dfAmountNet: i?.dfAmountNet || 0,
          cfAmount: i.dfAmount === null && i.cfAmount === null ? null : Number(i.cfAmount),
          cfDiscountAmount: Number(i.cfDiscountAmount) || 0,
          cfDiscountUnit: i.cfDiscountUnit || '',
          cfAmountNet: Number(i.cfAmountNet) || 0,
          dfRemark: i.dfRemark || '',
          clinicFeeId: Number(i.clinicFeeId) || null,
          total: Number(i.total) || 0,
          note: i.note || '',
          noteNextVisit: i.noteNextVisit || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          nextVisit: i.nextVisit || null,
          commission: i.commission || 0,
          // refItemId: i?.refItemId || 0,
          isChangeCost: i?.isChangeCost || "0",
          bodyData: i?.bodyData || "",
          newBodyData: i?.newBodyData || "",
          requestReason: i?.requestReason || "",
          promotion: i?.promotion?.length ? i?.promotion.map((item: any) => {
            return {
              promotionBranchId: item?.promotionBranchId,
              promotionType: item?.promotionType || item?.type,
              promotionId: item?.promotionId,
              isMain: item?.isMain || '0',
              groupNumber: item?.groupNumber || 0
            }
          }) : [],
          promotionDiscount: i?.promotionDiscount || 0,
          promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
          dfPromotionDiscountAmount: i?.dfPromotionDiscountAmount || 0,
          dfPromotionDiscountUnit: i?.dfPromotionDiscountUnit || "BAHT",
          cfPromotionDiscountAmount: i?.cfPromotionDiscountAmount || 0,
          cfPromotionDiscountUnit: i?.cfPromotionDiscountUnit || "BAHT",
          // 
          voucherListId: i?.voucherListId || 0,
          voucherDiscount: i?.voucherDiscount || 0,
          voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
          dfVoucherDiscountAmount: i?.dfVoucherDiscountAmount || 0,
          dfVoucherDiscountUnit: i?.dfVoucherDiscountUnit || "BAHT",
          cfVoucherDiscountAmount: i?.cfVoucherDiscountAmount || 0,
          cfVoucherDiscountUnit: i?.cfVoucherDiscountUnit || "BAHT",
          // 
          installment: i?.installment || null,
        })
      }

      if (!i.operativeTypeId) {
        summeryProducts.push({
          index: index + 1,
          tempOrderProductId: i.tempOrderProductId || null,
          inventoryId: i.inventoryId,
          itemId: i.itemId,
          itemName: i.itemName,
          group: i.group,
          qty: Number(i.qty),
          price: Number(i.price),
          doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || 'BAHT',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit || 'BAHT',
          note: i.note || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          total: Number(i.total) || 0,
          commission: i.commission || 0,
          promotion: i?.promotion?.length ? i?.promotion.map((item: any) => {
            return {
              promotionBranchId: item?.promotionBranchId,
              promotionType: item?.promotionType || item?.type,
              promotionId: item?.promotionId,
              isMain: item?.isMain || '0',
              groupNumber: item?.groupNumber || 0
            }
          }) : [],
          promotionDiscount: i?.promotionDiscount || 0,
          promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
          // 
          voucherListId: i?.voucherListId || 0,
          voucherDiscount: i?.voucherDiscount || 0,
          voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
        })
      }
    })

    _.map(treatments.patientDiagnosis, (i: any, index: number) => {
      summeryDiagnosis.push({
        // patientDiagnosisId: i.patientDiagnosisId || null,
        diagnosisId: Number(i.diagnosisId) || 0,
        doctorId: _.some(doctors, { 'userId': Number(i.doctorId) }) ? Number(i.doctorId) : 0,
        note: i.note || '',
        teeth: i?.teeth || null,
        teethJson: i?.teethJson || null,
        teethType: i?.teethType || treatments?.teethType || 'ADULT',
        // refItemId: i?.refItemId
      })
    })

    _.map(treatments.patientRecommends, (i: any, index: number) => {
      summeryRecommends.push({
        patientRecommendId: i.patientRecommendId || null,
        recommendId: i.recommendId,
        refItemId: JSON.stringify(i?.refItemId || '[]') || '[]'
      })
    })

    const summary = {
      importantSymptomsDoctor: patient.importantSymptomsDoctor || '',
      teethType: treatments?.teethType || 'ADULT',
      toothChart: await onHandleSaveToothChart(),
      servicePointId: treatments.servicePointId,
      summeryTreatments: summeryTreatments,
      summeryProducts: summeryProducts,
      patientDiagnosis: summeryDiagnosis,
      patientRecommends: summeryRecommends,
    }

    if (_.some(summary.summeryTreatments, { 'qty': 0 }) || _.some(summary.summeryProducts, { 'qty': 0 })) {
      setLoading(false)
      return notiError(t(`TREATMENT_SUMMARY.MESSAGE.${_.some(summary.summeryTreatments, { 'qty': 0 }) ? 'NO_OPERATIVE_QTY' : 'NO_PRODUCT_QTY'}`), '', null, null, 'register-page')
    }

    if (_.some(summary.summeryTreatments, { 'doctorId': 0 })) {
      setLoading(false)
      return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_TREATMENT'), '', null, null, 'register-page')
    }
    if (Config.IS_TDH === '1' || Config.IS_DIO === '1') {
      if (_.some(summary.summeryProducts, { group: 'MEDICINE', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_MEDICINE'), '', null, null, 'register-page')
      }

      if (_.some(summary.summeryProducts, { group: 'PRODUCT', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_PRODUCT'), '', null, null, 'register-page')
      }

      if (_.some(summary.summeryProducts, { group: 'MATERIAL', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_PRODUCT'), '', null, null, 'register-page')
      }
    }

    if (_.some(summary.patientDiagnosis, { 'doctorId': 0 })) {
      setLoading(false)
      return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_DIAGNOSIS'), '', null, null, 'register-page')
    }


    try {
      await RetrospectiveApi.postRetrospectivePatient(patientId, summary).then(() => notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'), '', null, null, 'register-page'))
      await RetrospectiveApi.getRetrospectivePatient(patientId).then((resp: any) => {
        dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: resp.data?.summeryTreatments }))
      })
      setLoading(false)
    } catch (err) {
      notiError(t('RETROSPECTIVE_ORDER.MESSAGE.ERROR.DEFAULT'), '', null, null, 'register-page')
      setLoading(false)
    }
  }

  const handlePayment = async (val: any) => {
    const retrospective: any = retrospectiveOrder
    retrospective.payment = val
    setLoading(true)
    await RetrospectiveApi.payment(patientId, retrospective)
      .then((resp) => {
        if (resp.status === 201) {
          setSendPayment(false)
          notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reload', null, null, 'register-page')
          if (resp.data) window.open(`${fileUrl}/${resp.data}`, '_blank')
          clearPatient()
          dispatch(resetStatePayment())
        } else {
          notiError(t('RETROSPECTIVE_ORDER.MESSAGE.ERROR.DEFAULT'), '', null, null, 'register-page')
        }
      })
      .catch((e) => {
        const message = e?.response?.data?.message
        if (message === 'TREATMENT_NOT_FOUND' || message === 'PRODUCT_NOT_FOUND') {
          return swalWarning(`รายการ ${e?.response?.data?.name} นั้นถูกลบไปแล้ว กรุณาลบรายการออก`)
        } if (message === 'PRODUCT_NOT_ENOUGH' || message === 'MEDICINE_NOT_ENOUGH') {
          notiError(`${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT')} ${e?.response?.data?.name || ''} ${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT_NOT')}`)
        } else {
          notiError(t('RETROSPECTIVE_ORDER.MESSAGE.ERROR.DEFAULT'), '', null, null, 'register-page')

        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    const rawDiscount: number[] = []
    const rawAdditional: number[] = []
    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      const additional: RawAdditionalType = {
        price: i.price,
        qty: i.qty,
        additional: Number(i.additional || 0),
        additionalUnit: i.additionalUnit
      }
      const discount: RawDiscountType = {
        price: i.price,
        qty: i.qty,
        discount: Number(i.discount || 0),
        discountUnit: i.discountUnit,
        dfUnit: i.dfUnit || 0,
        dfAmount: Number(i.dfAmount || 0),
        dfDiscountAmount: Number(i.dfDiscountAmount || 0),
        dfDiscountUnit: i.dfDiscountUnit || '',
        cfAmount: Number(i.cfAmount) || 0,
        cfDiscountAmount: Number(i.cfDiscountAmount || 0),
        cfDiscountUnit: i.cfDiscountUnit || '',
        additionalNet: renderSumAdditional(additional),
        doctorFeeAmount: i.doctorFeeAmount || 0,
        clinicFeeAmount: i.clinicFeeAmount || 0,
        additional: Number(i.additional || 0),
        additionalUnit: i.additionalUnit
      }
      rawDiscount.push(renderSumDiscount(discount))
      rawAdditional.push(renderSumAdditional(additional))
    })
    setNetDiscount(_.sum(rawDiscount))
    setNetAdditional(_.sum(rawAdditional))
  }, [treatments.summeryTreatments])

  useEffect(() => {
    clearOperative()
  }, [patient.patientId])

  useEffect(() => {
    loadDoctor()
    loadUsersList()
  }, [])

  useEffect(() => {
    loadRetrospectiveOrderList()
  }, [page, pageLimit])


  const exportOpd = async (valuePatientId: number) => {
    setLoading(true)
    exportOPD(valuePatientId)
      .catch((e) => {
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handlePatientCode = () => {
    if (branch?.patientCodeQueue === '1') {
      return patient.cnNumber ?? ''
    }
    if (branch?.patientCodeQueue === '0') {
      return patient.branchCnNumber ?? ''
    }

    if (branch?.patientCodeQueue === '2') {
      return patient.snCode ?? ''
    }
  }

  useEffect(() => {
    const subMenus: any = []
    const addonDoctorNote: TABS_NAME[] = checkPackage(PACKAGE_ADDONS.ADDON_DOCTOR_NOTE) ? [TABS_NAME.DOCTOR_NOTE] : []
    setTabs([TABS_NAME.OPD, ...addonDoctorNote, TABS_NAME.IMAGE, TABS_NAME.VITAL_SIGN])

    if (user?.hasDiagnosis === 'PERMISS') subMenus.push(SUB_TABS_NAME.DX)
    if (user?.hasTreatment === 'PERMISS') subMenus.push(SUB_TABS_NAME.TX)
    if (user?.hasTreatmentPlan === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_TREATMENT_PLAN_MANAGE)) subMenus.push(SUB_TABS_NAME.TXP)
    if (user?.hasTreatmentCourse === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_TREATMENT_COURSE_MANAGE)) subMenus.push(SUB_TABS_NAME.TXC)
    if (user?.hasMed === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_PRODUCTS)) subMenus.push(SUB_TABS_NAME.MED)
    if (user?.hasProduct === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_PRODUCTS)) subMenus.push(SUB_TABS_NAME.PD)
    // subMenus.push(SUB_TABS_NAME.MAT)
    setSubTabs([...subMenus])
  }, [user])

  const headCells = [
    { id: 'massage', disablePadding: false, align: 'center', label: t('#'), width: '100px' },
    { id: 'massage', disablePadding: false, align: 'left', label: t('RETROSPECTIVE_ORDER.TABLE.PATIENT_NAME') },
    { id: 'massage', disablePadding: false, align: 'center', label: t('RETROSPECTIVE_ORDER.TABLE.DATE'), width: '190px' },
    { id: 'massage', disablePadding: false, align: 'center', label: t('RETROSPECTIVE_ORDER.TABLE.UPDATED_BY'), width: '180px' },
    { id: 'massage', disablePadding: false, align: 'center', label: t('Action'), width: '160px' },
  ]

  const renderData = (objData: any, no: number,) => {
    const num = page * 5 - 5 + no + 1

    // const style = { border: exportData ? `0px solid ${colors.black}` : '', fontSize: exportData ? 10 : 16 }
    const objRenderData = {
      key: String(objData?.patientId),
      id: String(objData?.patientId),
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', width: '80px', label: num },
        { option: 'TEXT', align: 'left', label: objData?.patient?.patientFullName || '', class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: objData?.date ? dateToView(objData?.date || '') : '-', class: 'text-nowrap' },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: objData?.createdBy } },
        {
          option: 'COMPONENT', align: 'center', component:
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box className="mr-1" aria-label="add" onClick={() => {
                setIsOpenModal(false)
                loadRetrospectivePatient(objData?.patientId)
              }} sx={{ backgroundColor: '#1CB99A', borderRadius: '3px', width: '24px', height: '24px', cursor: 'pointer' }}>
                <img src={icons.btnUp} alt="add" style={{ color: 'white', alignItems: 'center' }} />
              </Box>
            </Box>
          , class: 'text-nowrap'
        }
      ]
    }

    return <>{<TableRowCommon {...objRenderData} />}</>
  }
  return (
    <div>
      <PageModal
        isOpen={isOpenModal}
        title='ผู้ป่วยรอลงรายการย้อนหลัง'
        size='M'
        overflow
        handleClose={() => setIsOpenModal(false)}
        onCancel={{ onClick: () => setIsOpenModal(false) }}
        onSubmit={{ onClick: () => null }}
        onCloseSubmit
      >
        <Box paddingTop="16px">
          <Grid container spacing="8px">
            <Grid item xs={10}>
              <Grid container spacing="8px">
                <Grid item xs={3}>
                  <TextInput onChange={(e) => setSearch(e.target.value)} label='ค้นหา ชื่อผู้ป่วย' fullWidth />
                </Grid>
                <Grid item xs={3}>
                  <DateInput
                    label='วันที่ทำรายการย้อนหลัง'
                    onChange={(e) => setDateModal(format(e, 'yyyy-MM-dd'))}
                    value={dateModal}
                    onClear={(e) => {
                      e.stopPropagation()
                      setDateModal('')
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <SelectCheckBoxInput
                    onChange={(e: any) => {
                      setUserId(e)
                      const result = e.join(',')
                      setResultUserId(result)
                    }}
                    options={optionUsers}
                    selected={userId}
                    fullWidth
                    label='ผู้บันทึก'
                  />

                </Grid>
                <Grid item xs={3}>
                  <DateRangeInput
                    inputHeight={40}
                    value={rangeDate || ['', '']}
                    onchange={(val: any) => {
                      if (_.isEmpty(val)) setRangeDate(['', ''])
                      else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                    }}
                    label={''}
                    allowClear
                    onClear={() => setRangeDate(['', ''])}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <MainButton title='' type='primary' variant='contained' onClick={() => loadRetrospectiveOrderList()} style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Box marginTop="16px">
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              onSort={() => null}
              rowCount={rowCount}
              setPage={(e) => setPage(e)}
              setPageLimit={(e) => setPageLimit(e)}
              sortBy=''
              sortType=''
              headCells={headCells}
              rowsData={_.map(retrospectiveList, (i, index: number) => {
                return renderData(i, index)
              })}
            />
          </Box>
        </Box>
      </PageModal>
      <AlertModal
        isOpen={isOpenAlertWarning}
        title='ทำรายการต่อจากเดิม'
        message={`ผู้ป่วยมีรายการรักษาย้อนหลังที่ค้างอยุ่\nหากคุณต้องการทำต่อ กรุณากดยืนยัน`}
        type='warning'
        handleClose={() => setIsOpenAlertWarning(false)}
        onCancel={{ onClick: () => setIsOpenAlertError(true), type: 'danger', title: 'ทำรายการใหม่' }}
        onSubmit={{
          onClick: async () => {
            setIsOpenAlertWarning(false)
          }, title: 'ยืนยัน'
        }}
      />
      <AlertModal
        isOpen={isOpenAlertError}
        title='ทำรายการใหม่'
        message={`ข้อมูลลงรายการย้อนหลังที่ถูกบันทึกไว้ก่อนหน้านี้จะถูกลบออก\nคุณต้องการที่จะยืนยันการลบรายการ  ใช่หรือไม่ `}
        type='error'
        handleClose={() => setIsOpenAlertError(false)}
        onCancel={{ onClick: () => setIsOpenAlertError(false) }}
        onSubmit={{
          onClick: () => onDeleteRetrospective(patient?.patientId), title: 'ยืนยัน'
        }}
      />
      <HeaderCard text={t('RETROSPECTIVE_ORDER.HEADER')} />
      <UseStyled.RetrospectiveOrder>
        <Box className={`px-3 px-md-4 pt-3 pt-md-4 pb-4 ${activeTab === TABS_NAME.IMAGE ? 'h-100' : ''}`}>
          <Box sx={{ paddingBottom: '56px' }}>
            <Grid container spacing={2} className="mb-3">
              <Grid item className='w-100'>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box sx={{ width: '650px' }}>
                    <SearchPatients
                      status="ACTIVE"
                      // callbackPatientId={getPatientId} 
                      callbackPatient={getPatient}
                      patientId={patient.patientId}
                      patient={patient}
                      onClear={clearPatient}
                    />
                  </Box>
                  <MainButton title=' ผู้ป่วยรอลงรายการย้อนหลัง' type='primary' variant='outlined' onClick={() => setIsOpenModal(true)} />
                </Box>
              </Grid>
              <Grid item className="w-100">
                <TreatmentsUseStyled.CardProfile className={`d-flex px-3 ${!patient.patientId ? 'pe-none' : ''}`} onClick={onViewHistory}>
                  <BtnProfile disabled={!patient.patientId} profile={renderImage(patient.profile)} branchCnNumber={handlePatientCode() || ''} firstName={patient.firstname} lastName={patient.lastname} rankId={patient.rankId} lastVisit={patient.updatedAt} />
                </TreatmentsUseStyled.CardProfile>
              </Grid>
              <Grid item className={`w-100 ${activeTab !== TABS_NAME.OPD ? 'd-none' : ''}`}>
                <UseStyled.InputDate className="w-100">
                  {/* <DateInput
                    label={t('RETROSPECTIVE_ORDER.FORM.DATE')}
                    onChange={(e: any) => {
                      setDate(moment(e).format('YYYY-MM-DD'))
                      setErrorMessage({ EMPTY_DATE: '' })
                    }}
                    value={date}
                    disabled={!patient.patientId}
                    disabledDateFuture
                    helperText={errorMessage.EMPTY_DATE || ''}
                    fullWidth
                    startDate={moment('2025-02-11').format('yyyy-MM-DD')}
                  /> */}
                  <InputSecondNewDatePicker
                    required
                    disableFuture
                    maxDate={new DateObject().subtract(1, "day")}
                    hideTodayButton
                    label={t('RETROSPECTIVE_ORDER.FORM.DATE')}
                    disabled={!patient.patientId}
                    value={date}
                    onchange={(e: any) => {
                      setDate(moment(e).format('YYYY-MM-DD'))
                      setErrorMessage({ EMPTY_DATE: '' })
                    }}
                    helperText={errorMessage.EMPTY_DATE || ''}
                  />
                </UseStyled.InputDate>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item className="w-100">
                <TreatmentsUseStyled.CustomTabs disabled={!patient.patientId}>
                  <Tabs value={activeTab} onChange={handleChangeTab} aria-label="payment tab" className="d-none d-md-block">
                    {_.map(tabs, (title: string, index: number) => {
                      return (
                        (index === 0 && (
                          <>
                            <TreatmentsUseStyled.CustomButton
                              key={`tabChild-${index}`}
                              aria-haspopup="true"
                              aria-expanded={openTabletTabs ? 'true' : undefined}
                              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                handleChangeTab(event, 0)
                                setAnchorElTabletTabs(event.currentTarget)
                                handleOpenDropDown()
                              }}
                              className={`btn-tab btn-dropdown-menu-tablet-tab ${activeTab === TABS_NAME.OPD ? 'Mui-selected' : ''}`}
                              disableRipple
                              disabled={!patient.patientId}
                              {...a11yProps(index)}
                            >
                              <span>{t(title)}</span>
                              <span className={'d-xl-none pl-1'}>({activeSubTab})</span>
                              <FontAwesomeIcon icon={faCaretDown} className={'icon-selector d-xl-none'} />
                            </TreatmentsUseStyled.CustomButton>
                            <TreatmentsUseStyled.MenuBtnMore
                              id="basic-menu-more"
                              anchorEl={anchorElTabletTabs}
                              open={openTabletTabs}
                              onClose={onCloseMenu}
                              onClick={onCloseMenu}
                              className="d-xl-none"
                              sx={{
                                '.MuiMenu-list': {
                                  width: tabletWidth,
                                  maxHeight: '270px'
                                }
                              }}
                            >
                              {_.map(subTabs, (subTab: SUB_TABS_NAME, indexSubTab: number) => {
                                return (
                                  <MenuItem
                                    key={indexSubTab}
                                    className={'d-block text-ellipsis'}
                                    onClick={() => {
                                      setActiveTab(tabs[0])
                                      setActiveSubTab(subTab)
                                      if (indexSubTab === 0) setActiveFooterTab(1)
                                      else setActiveFooterTab(0)
                                    }}
                                  >
                                    {subTab}
                                  </MenuItem>
                                )
                              })}
                            </TreatmentsUseStyled.MenuBtnMore>
                          </>
                        )) || <Tab key={`tab-${index}`} label={t(title)} {...a11yProps(index)} className={`btn-tab ${activeTab === title ? 'Mui-selected' : ''}`} disableRipple />
                      )
                    })}
                  </Tabs>
                </TreatmentsUseStyled.CustomTabs>

                <TreatmentsUseStyled.CustomTabs disabled={!patient.patientId} className="d-md-none">
                  <TreatmentsUseStyled.CustomButton
                    id="mobile-tabs"
                    aria-controls={openMobileTabs ? 'basic-menu-more' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMobileTabs ? 'true' : undefined}
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                      setAnchorElMobileTabs(event.currentTarget)
                      handleOpenDropDown()
                    }}
                    className={'btn-tab btn-dropdown-menu-mobile-tab'}
                    disableRipple
                  >
                    {activeTab === TABS_NAME.OPD ? `OPD (${activeSubTab})` : t(activeTab)}
                    <FontAwesomeIcon icon={faCaretDown} className={'icon-selector'} />
                  </TreatmentsUseStyled.CustomButton>

                  <TreatmentsUseStyled.MenuBtnMore
                    id="basic-menu-more"
                    anchorEl={anchorElMobileTabs}
                    open={openMobileTabs}
                    onClose={onCloseMenu}
                    onClick={onCloseMenu}
                    className="d-xl-none"
                    sx={{
                      '.MuiMenu-list': {
                        width: mobileWidth,
                        maxHeight: '270px'
                      }
                    }}
                  >
                    <Typography className="pb-1 px-3" sx={{ fontWeight: 600 }}>
                      {t(tabs[0])}
                    </Typography>
                    {_.map(subTabs, (subTab: SUB_TABS_NAME, indexSubTab: number) => {
                      return (
                        <MenuItem
                          key={indexSubTab}
                          className={'d-block text-ellipsis'}
                          onClick={() => {
                            setActiveTab(tabs[0])
                            setActiveSubTab(subTab)
                            if (indexSubTab === 0) setActiveFooterTab(1)
                            else setActiveFooterTab(0)
                          }}
                        >
                          {subTab}
                        </MenuItem>
                      )
                    })}
                    <Divider className="mx-0" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    {_.map(tabs, (title: string, indexTitle: number) => {
                      if (indexTitle > 0)
                        return (
                          <MenuItem key={indexTitle} className={'d-block text-ellipsis'} onClick={() => setActiveTab(tabs[indexTitle])}>
                            {t(title)}
                          </MenuItem>
                        )
                    })}
                  </TreatmentsUseStyled.MenuBtnMore>
                </TreatmentsUseStyled.CustomTabs>
              </Grid>
              <Grid item className={`w-100 ${activeTab === TABS_NAME.OPD ? 'mt-md-3' : 'mt-3'} ${!patient.patientId ? 'pe-none' : ''}`}>
                <TabPanel value={activeTab} index={TABS_NAME.OPD}>
                  <IndexOPD
                    type="RetrospectiveOrder"
                    userId={user.userId}
                    patient={patient}
                    tabs={subTabs}
                    activeTab={activeSubTab}
                    setActiveTab={(tab: SUB_TABS_NAME) => setActiveSubTab(tab)}
                    setFooterActiveTab={(tab: number) => setActiveFooterTab(tab)}
                    disabledMenu={!patient.patientId}
                    hasChangeProductPrice={user?.hasChangePrice}
                    hasChangeProductDiscountAdditional={user?.hasChangeDiscountAdditional}
                    hasCreateTreatment={user?.hasCreateTreatment || 'PERMISS'}
                    hasCreateTreatmentPlan={user?.hasCreateTreatmentPlan || 'PERMISS'}
                    hasCreateTreatmentCourse={user?.hasCreateTreatmentCourse || 'PERMISS'}
                    medShowType={branch?.medShowType}
                    pdShowType={branch?.pdShowType}
                  />
                </TabPanel>
                <TabPanel value={activeTab} index={TABS_NAME.DOCTOR_NOTE}>
                  <IndexDoctorNote userId={user.userId} patient={patient} hasDoctorNote={user?.hasDoctorNote} hasCreateDoctorNote={user?.hasCreateDoctorNote || 'PERMISS'} hasDeleteDoctorNote={user?.hasDeleteDoctorNote} />
                </TabPanel>
                <TabPanel value={activeTab} index={TABS_NAME.IMAGE}>
                  <IndexImage patient={patient} />
                </TabPanel>
                <TabPanel value={activeTab} index={TABS_NAME.VITAL_SIGN}>
                  <IndexVitalSign patient={patient} loadPatient={(val: any) => loadPatient(val)} />
                </TabPanel>
              </Grid>
            </Grid>

            {activeTab !== TABS_NAME.VITAL_SIGN && (
              <Box className="w-100">
                <IndexSummaryTreatment
                  userId={user.userId}
                  type="RetrospectiveOrder"
                  tabs={footerTabs}
                  activeTab={activeFooterTab}
                  setActiveTab={(tab: number) => {
                    setActiveFooterTab(tab)
                    if (tab === 0) setActiveSubTab(SUB_TABS_NAME.TX)
                    else if (tab === 1) setActiveSubTab(SUB_TABS_NAME.DX)
                  }}
                  patientCaseId={patient.patientCase?.patientCaseId}
                  patientId={patient.patientId}
                  patientName={`${patient.firstname} ${patient.lastname}`}
                  doctors={doctors}
                  hasTreatment={user?.hasTreatment}
                  hasChangeTreatmentCost={user?.hasChangeTreatmentCost}
                  hasChangeTreatmentNote={user?.hasChangeTreatmentNote}
                  hasChangeProductPrice={user?.hasChangePrice}
                  hasChangeProductDiscountAdditional={user?.hasChangeDiscountAdditional}
                  hasDiagnosis={user?.hasDiagnosis}
                  hasDeleteTreatment={user?.hasDeleteTreatment || 'PERMISS'}
                  patientPhone={patient.phone}
                />
              </Box>
            )}
          </Box>

          {activeTab !== TABS_NAME.VITAL_SIGN && (
            <FragmentFooter
              type="RetrospectiveOrder"
              onPayment={() => onPayment()}
              netTotal={_.sumBy(treatments.summeryTreatments.map((item: any) => {
                let total = item?.installment ? _.find(item?.installment?.installmentList, (item) => item.status === 'PENDING')?.price : item.total
                if (item?.approvalItems?.status === ApprovalStatus.PENDING) {
                  const newData = JSON.parse(item?.approvalItems?.body)
                  total = newData?.total
                }
                return { ...item, total }
              }), 'total')}
              netDiscount={netDiscount}
              netAdditional={netAdditional}
              onExportSSO={exportSSO}
              onExportOPD={() => exportOpd(patient.patientId)}
              disabled={!patient.patientId}
              tabActive={activeSubTab}
              patientName={`${patient.firstname} ${patient.lastname}`}
              showButtonPrintMedicineSticker={false}
              patientCaseId={patient?.patientCase?.patientCaseId}
              onSaveRetro={() => onSaveRetrospective(patient?.patientId)}
            />
          )}

          {exportMedicalCertificate && (
            <MedicalCertificate
              isShow={exportMedicalCertificate}
              setIsShow={(show: boolean) => setExportMedicalCertificate(show)}
              patientId={patient.patientId}
              patientCaseId={patient.patientCase.patientCaseId}
              createdAt={patient.createdAt}
              type={'treatment'}
            />
          )}
          {loading && <Loading show={true} type="fullLoading" />}
          {sendPayment && <PopupPayment type="RETROSPECTIVE" isShow={sendPayment} setIsShow={(show: boolean) => setSendPayment(show)} patient={patient} onSuccess={handlePayment} date={date} />}
          <PopupPatientDetail type="retrospective" profile={renderImage(patient.profile)} patient={patient} showPopup={isShowPopupDetail} onClose={() => setIsShowPopupDetail(false)} />
        </Box>
      </UseStyled.RetrospectiveOrder>
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `payment-tab-${index}`,
    'aria-controls': `payment-tabpanel-${index}`
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div role="tab" hidden={value !== index} id={`payment-tab-${index}`} aria-labelledby={`payment-tabpanel-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  )
}
